export default "__VITE_ASSET__Cqsh4h2O__"